/**
 * Create a number range
 *
 * @param size the size of the range to create
 * @param options.startAt the first number in the range, defaults to 0
 * @param options.step the increment between each number in the range defaults to 1
 * @returns a number range
 */
export default function range(size, {
  startAt = 0,
  step = 1
} = {}) {
  return [...Array.from({
    length: size
  }).keys()].map(index => index * step + startAt);
}